import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import Card from 'components/card';
import { markTaskAsDone } from 'interfaces/task';

function TodayAgenda(props: { tasks: any[]; onTaskDone: (id: string) => void }) {
    const { tasks, onTaskDone } = props;
    const navigate = useNavigate();

    const handleMarkDone = async (id: string) => {
        await markTaskAsDone(id);
        onTaskDone(id);
    };

    return (
        <Card extra="px-[34px] pt-3 pb-5 rounded-[20px] w-full border">
            <div className="flex items-center justify-between">
                <div>
                    <h4 className="ml-px text-lg font-bold text-navy-700 dark:text-white">
                        Agenda commercial
                    </h4>
                    <p className="mb-2 capitalize">
                        {format(new Date(), "EEEE d MMMM", { locale: fr })}
                    </p>
                </div>
                <button
                    onClick={() => navigate('/tasks')}
                    className="whitespace-nowrap text-sm font-bold text-toola-500 transition-all hover:-translate-x-1 dark:text-white"
                >
                    Agenda complet →
                </button>
            </div>

            {!tasks || tasks.length === 0 ? (
                <p className="py-6 text-center text-sm text-gray-500">
                    Aucune tâche commerciale prévue aujourd'hui.
                </p>
            ) : (
                <div className="mt-2 max-h-[280px] space-y-2 overflow-y-auto">
                    {tasks.map((task: any) => (
                        <div
                            key={task._id}
                            className="flex items-start justify-between gap-3 rounded-xl bg-lightPrimary p-3"
                        >
                            <div className="min-w-0 flex-1">
                                <p className="truncate text-sm font-medium text-navy-700">
                                    {task.customer?.company}
                                </p>
                                <p className="truncate text-sm text-gray-500">{task.content}</p>
                            </div>
                            <button
                                onClick={() => handleMarkDone(task._id)}
                                className="flex-shrink-0 whitespace-nowrap rounded-lg bg-toola-400 px-3 py-1.5 text-xs text-white"
                            >
                                Fait
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </Card>
    );
}

export default TodayAgenda;
